import $ = require("jquery");
import MapServer = require("arcgis/services/mapserver");
import ArcgisServices = require("../../models/arcgis-services");
import Utils = require("../../utils");
import Portal = require("portal-gis");
import AgsLayers = require("./ags-layers");

class AgsMapServer {

    static about = `
_mapserverService_ gets layers from an ArcGIS Service.
    `;

    static mapserverService(url: string) {
        var s = new ArcgisServices.ServiceDirectoryModel();
        var d = $.Deferred<Array<Portal.MapLayerLeaf>>();

        var service = s.exploreService({ url: url });

        s.fetchService<MapServer.MapServer>(service).done(service => {
            var layers = AgsLayers.asLayers(service);
            d.resolve(layers);
        });

        return d;
    }
}

export = AgsMapServer;